import React, { useState } from "react";
import { useSiteData } from "../../context/SiteDataContext";
import { ChevronDown } from "lucide-react";

const FAQItem = ({ item, isOpen, onToggle }) => (
  <div className={`border rounded-xl transition-all duration-300 ${isOpen ? "border-yellow-400/30 bg-[#0d1a0d]" : "border-[#1a3a1a] bg-[#0d1a0d]/50 hover:border-yellow-400/20"}`}>
    <button onClick={onToggle} className="w-full flex items-center justify-between p-5 text-left">
      <span className={`font-bold text-base transition-colors duration-200 ${isOpen ? "text-yellow-400" : "text-white"}`}>{item.question}</span>
      <ChevronDown size={20} className={`text-yellow-400 transition-transform duration-300 flex-shrink-0 ml-4 ${isOpen ? "rotate-180" : ""}`} />
    </button>
    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}>
      <p className="px-5 pb-5 text-gray-400 text-sm leading-relaxed">{item.answer}</p>
    </div>
  </div>
);

const FAQSection = () => {
  const [openId, setOpenId] = useState(null);
  const { content } = useSiteData();
  const faq = content?.faq || [];

  return (
    <section id="faq" className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[#060d06]" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-12">
          <span className="text-yellow-400">FREQUENTLY ASKED</span>{" "}
          <span className="text-white">QUESTIONS</span>
        </h2>
        <div className="flex flex-col gap-4">
          {faq.map((item, i) => (
            <FAQItem key={i} item={item} isOpen={openId === i} onToggle={() => setOpenId(openId === i ? null : i)} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
